import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DOOD_API } from '@config/ws.config';
import {
  ContentBuilderSpecApiResponse,
  ContentBuilderSpecRuntimePayload,
} from '@core/services/cb2-preview/runtime/content-builder-spec.model';
import {
  adaptCompiledSpecToDoodRuntime,
  toCompiledSpecFromApiResponse,
} from '@core/services/cb2-preview/runtime/content-builder-spec.adapter';

@Injectable({
  providedIn: 'root',
})
export class MarketplacesContentBuilderApiService {
  constructor(private readonly client: HttpClient) {}

  public getCompiledRuntime$(
    marketplaceId: string,
    mode: 'draft' | 'live' = 'live',
  ): Observable<ContentBuilderSpecRuntimePayload> {
    const url = `${DOOD_API}/marketplaces/${marketplaceId}/content-builder-compiled`;
    const params = new HttpParams().set('mode', mode);

    return this.client.get<ContentBuilderSpecApiResponse>(url, { params }).pipe(
      map(response => toCompiledSpecFromApiResponse(response)),
      map(compiled => adaptCompiledSpecToDoodRuntime(compiled)),
    );
  }
}
